import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { ApiService, HttpParamsOptions } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';
import { Config } from 'datatables.net';
import Swal from 'sweetalert2';
import * as FileSaver from 'file-saver';

class DataTablesResponse {
	data!: any[];
	draw!: number;
	recordsFiltered!: number;
	recordsTotal!: number;
}

@Component({
	selector: 'app-invoice-list',
	templateUrl: './invoice-list.component.html',
	styleUrl: './invoice-list.component.css'
})
export class InvoiceListComponent implements OnInit, OnDestroy, AfterViewInit {
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/invoice-list",
			name: "Invoice"
		}
	];

	@ViewChild(DataTableDirective, { static: false }) datatableElement!: DataTableDirective;
	baseURL = environment.API_URL;
	dtOptions: Config = {};
	dataList: any = [];
	allFlagStates: any[] = [];
	flagState: any = null;
	moduleAccess: any = "Full";
	accessLoader = false;
	currencyList: any[] = [];
	showIsPaidLoader: any = null;
	pdfDownloadLoader: any = null;
	showDeleteLoader: any = null;

	constructor(private formBuilder: FormBuilder, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, private http: HttpClient) { }

	ngOnInit(): void {
		this.getCurrencyList();
		this.initDatatable();
	}

	ngOnDestroy(): void {

	}

	ngAfterViewInit(): void {

	}

	initDatatable() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			serverSide: true,
			processing: true,
			ordering: false,
			language: {
				searchPlaceholder: "Search",
				search: ""
			},
			ajax: (dataTablesParameters: any, callback) => {
				let data: any = {
					draw: dataTablesParameters.draw,
					start: dataTablesParameters.start,
					length: dataTablesParameters.length
				}
				if (dataTablesParameters.search.value != "") {
					data.search = dataTablesParameters.search.value;
				}
				const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
				this.http.get<DataTablesResponse>(this.baseURL + "InvoiceApi", { params: new HttpParams(httpParams) }).subscribe({
					next: (response: any) => {
						for (let i = 0; i < response.data.length; i++) {
							response.data[i].paid_unpaid = response.data[i].paid_unpaid ? true : false;
							response.data[i].paid_unpaid_temp = response.data[i].paid_unpaid;
							response.data[i].amount = response.data[i].amount !== null && response.data[i].amount !== "" ? Math.round((parseFloat(response.data[i].amount) + Number.EPSILON) * 100) / 100 : null;
						}
						this.dataList = response.data;
						callback({
							recordsTotal: response.recordsTotal,
							recordsFiltered: response.recordsFiltered,
							data: []
						});
					}, error: (error: any) => {
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong.", 'Error!!!', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		}
	}

	refreshTable() {
		this.datatableElement.dtInstance.then((dtInstance) => {
			dtInstance.draw();
		});
	}

	getCurrencyList() {
		this.apiService.getCurrency({}).subscribe({
			next: (data: any) => {
				this.currencyList = data;
			}, error: (err: any) => {
				this.currencyList = [];
			}
		});
	}

	getCurrencyName(id: any) {
		let currencyName = "";
		let len = this.currencyList.length;
		for (let i = 0; i < len; i++) {
			if (id == this.currencyList[i].nid) {
				currencyName = this.currencyList[i].name;
			}
		}
		return currencyName;
	}

	getCurrencyIcon(id: any) {
		let currencyName = "";
		let len = this.currencyList.length;
		for (let i = 0; i < len; i++) {
			if (id == this.currencyList[i].nid) {
				currencyName = this.currencyList[i].name;
			}
		}
		let icon = "";
		if (currencyName == "USD" || currencyName == "SGD") {
			icon = "fa fa-usd";
		} else if (currencyName == "INR") {
			icon = "fa fa-rupee";
		}
		return icon;
	}

	changeIsPaid(po: any, index: number) {
		let isPaidStr = "";
		if (po.paid_unpaid) {
			isPaidStr = "Paid";
		} else {
			isPaidStr = "Unpaid";
		}
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to change status to <strong>' + isPaidStr + '</strong>?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Continue',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#f23022'
		}).then((result) => {
			if (result.value) {
				this.showIsPaidLoader = index;
				this.apiService.paid_unpaid({ id: po.id, status: po.paid_unpaid ? 1 : 0 }).subscribe({
					next: data => {
						this.showIsPaidLoader = null;
						this.dataList[index].paid_unpaid_temp = po.paid_unpaid;
						Swal.fire('Success', 'Updated successfully.', 'success');
					}, error: (error) => {
						this.showIsPaidLoader = null;
						if (error.status == 401) { return }
						Swal.fire('Error', "Something went wrong", 'error');
						po.paid_unpaid = po.paid_unpaid_temp;
					}
				});
			} else if (result.dismiss === Swal.DismissReason.cancel) {
				po.paid_unpaid = po.paid_unpaid_temp;
			}
		})
	}



	getBillPdf(inv: any) {
		let len = this.currencyList.length;
		let currencyName = "";
		for (let i = 0; i < len; i++) {
			if (inv.currency == this.currencyList[i].nid) {
				currencyName = this.currencyList[i].name;
			}
		}
		let data: any = {
			"id": inv.id,
			"currency": currencyName
		};
		this.pdfDownloadLoader = inv.id;
		this.apiService.getBillPdf(data).subscribe({
			next: (res: any) => {
				let pdfData: any = res.body;
				this.pdfDownloadLoader = null;
				let blob = new Blob([pdfData], { type: "application/pdf" });
				let fileName = inv.invoice_no + "_" + inv.company_name + ".pdf";
				FileSaver.saveAs(blob, fileName);
			}, error: (error) => {
				this.pdfDownloadLoader = null;
				if (error.status == 400) {
					const decodedString = String.fromCharCode(...new Uint8Array(error.error));
					this.toastr.error(decodedString, 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				} else {
					this.toastr.error("Unable to download file", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
				}
			}, complete: () => { }
		});
	}

	blobToSaveAs(fileName: string, blob: Blob) {

		try {
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			if (link.download !== undefined) { // feature detection
				link.setAttribute('href', url);
				link.setAttribute('download', fileName);
				link.style.visibility = 'hidden';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		} catch (e) { }
	}

	deleteModal(Id: any, index: any) {
		Swal.fire({
			title: 'Warning !!!',
			text: 'Are you sure you want to delete bill?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#f23022'
		}).then((result) => {
			if (result.value) {
				this.showDeleteLoader = index;
				this.apiService.deleteBill(Id).subscribe({
					next: (data: any) => {
						this.showDeleteLoader = null;
						this.dataList.splice(index, 1);
						Swal.fire('Success', 'Bill Deleted Successfully.', 'success');
					}, error: (error: any) => {
						this.showDeleteLoader = null;
						Swal.fire('Error', 'Something went wrong.', 'error');
					}
				});
			} else if (result.dismiss === Swal.DismissReason.cancel) { }
		})
	}
}
